(ns nl.mediquest.ui.core.notifications
  (:require
   [clojure.spec.alpha :as s]
   [integrant.core :as ig]
   [nl.mediquest.ui.css :refer [keyframes px inject-styles! level-bgs-0 level-bgs-1 level-icons]]
   [re-frame.core :as re-frame]))

(def styles
  [[:.notification {:animation-name :notification-slide-in
                    :animation-duration "1s"}]
   (keyframes :notification-slide-in
              [["0%"   {:left (px 500)}]
               ["100%" {:left (px 0)}]])])

(defn has-id? [notification notification-id]
  (-> notification
      :notification/id
      #{notification-id}))

(re-frame/reg-sub
 ::notifications
 ;; list of notifications, newest first, or nil
 (fn [db [_]]
   (get-in db [:nl.mediquest.ui ::notifications])))

(def ^:private level->timeout
  {:level/error 10000
   :level/success 5000})

(re-frame/reg-event-fx
 ::open
 (fn [{:keys [db]} [_ notification]]
   (let [new-id (random-uuid)]
     {:db (update-in db
                     [:nl.mediquest.ui ::notifications]
                     conj
                     (assoc notification :notification/id new-id))
      :fx [[:dispatch-later
            {:ms (level->timeout (:notification/level notification))
             :dispatch [::notification-timeout new-id]}]]})))

(re-frame/reg-fx
 ::fade-out-notification
 (fn [notification-id]
   ;; Fades due to `transition-all` and `duration-*` Tailwind classes on element.
   (when-let [node (.getElementById js/document (str "notification-" notification-id))]
     (let [style (.-style node)]
       (set! (.-transform style) "scale(1.0, 0.0)")
       (set! (.-opacity style) "0.0")))))

(re-frame/reg-event-fx
 ::notification-timeout
 (fn [_ [_ notification-id]]
   {::fade-out-notification notification-id
    :fx [[:dispatch-later {:ms 1500 ; a little over period used in transition duration
                           :dispatch [::close notification-id]}]]}))

(re-frame/reg-event-db
 ::close
 (fn [db [_ notification-id]]
   (update-in db [:nl.mediquest.ui ::notifications]
              (partial remove #(has-id? % notification-id)))))

(defn open! [notification]
  (re-frame/dispatch [::open notification]))

(defn close! [notification-id]
  (re-frame/dispatch [::close notification-id]))

(defn render-notification
  [{:notification/keys [id description level]} _opts]
  (let [width 600]
    [:div.my-1.w-full.flex.flex-col.items-end.origin-top-left.transition-all.duration-1000
     {:id (str "notification-" id)
      :on-click #(close! id)}
     [:div.notification.w-full.rounded.text-white.font-medium.relative.pointer-events-auto
      {:class [(get level-bgs-1 level)]
       :style {:max-width (px width)}}
      [:div.absolute.right-0.p-1.pr-3.cursor-pointer
       [:i.fa-close.fal.text-xl]]
      [:div.flex
       [:div.py-3.pl-8.pr-10.flex.items-center.rounded-l
        [:i.fas.w-1.text-xl
         {:class [(get level-icons level)]}]]
       [:div.pl-4.py-3.w-full.rounded-r
        {:class [(get level-bgs-0 level)]}
        [:div.pr-4
         description]]]]]))

(defn clear-notifications [db]
  (assoc-in db [:nl.mediquest.ui ::notifications] nil))

(re-frame/reg-event-db
 ::clear-notifications
 (fn [db [_]]
   (clear-notifications db)))

(defn show-error [message]
  (open!
   {:notification/description message
    :notification/level :level/error}))

(defn show-info [message]
  (open!
   {:notification/description message
    :notification/level :level/success}))

(re-frame/reg-fx
 ::notification
 (fn [{:keys [level message]}]
   (condp = level
     :info (show-info message)
     :error (show-error message))))

(defn view [opts]
  [:div.fixed.w-full.z-50.pointer-events-none
   [:div.p-4.w-full.pt-16
    (doall
     (for [notification @(re-frame/subscribe [::notifications])]
       ^{:key (:notification/id notification)}
       [render-notification notification opts]))]])

(defmethod ig/assert-key :component.ui/notifications [_k v]
  (assert (s/valid? (s/keys :req []) v)))

(defmethod ig/expand-key :component.ui/notifications [k opts]
  (inject-styles! ::styles styles)
  {k opts})

(defmethod ig/init-key :component.ui/notifications [_ opts]
  (fn []
    [view opts]))
